/**
 * Skeleton — minimal loading placeholder used by App.js's RouteFallback
 * while lazy-loaded pages are fetched. `components.json` scaffolds a
 * shadcn/ui `bg-muted` + `rounded-*` version, but this repo never added
 * the `--muted`/`--radius` CSS variables those classes depend on (see
 * tailwind.config.js), so this uses the repo's own existing `steel-3`
 * token instead and leaves rounding to the caller's className (every
 * current call site already passes `rounded`).
 */
export default function Skeleton({ className = "", ...props }) {
  return <div className={`animate-pulse bg-steel-3/20 ${className}`} {...props} />;
}
